import { render } from "./BFilterEditor.vue?vue&type=template&id=8d10f666&ts=true"
import script from "./BFilterEditor.vue?vue&type=script&lang=ts"
export * from "./BFilterEditor.vue?vue&type=script&lang=ts"

import "./BFilterEditor.vue?vue&type=style&index=0&id=8d10f666&lang=scss"

import exportComponent from "../../../../../../ss/AZ/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__